import React from "react";
import "./Majestry_Story.css"
import Common_Title_2 from "../../common_components/common_title_2/Common_Title_2";

function Majestry_Story() {
  return (
    <div className="majestry_section container">
     
        <Common_Title_2 title={"The Majesty Story: Engineering the Art of Sleep"}/>
      <div className="majestry_text">
        <p>
          At Majesty, we believe that a mattress is more than just a piece of
          furniture — it is the foundation of your health, your mood, & your
          daily success. Born from a passion for sleep science & a commitment to
          premium craftsmanship, Majesty was created to bridge the gap between
          advanced engineering and unrivaled luxury.
        </p>
      </div>
    </div>
  );
}

export default Majestry_Story;
